import { Path, Svg, SvgProps } from 'react-native-svg'

export default function JaFlag(props: SvgProps) {
  return (
    <Svg width="60" height="40" viewBox="0 0 60 40" fill="none" {...props}>
      <Path d="M60 0H0V40H60V0Z" fill="#ffffff" />
      <Path
        d="M30 32C36.6274 32 42 26.6274 42 20C42 13.3726 36.6274 8 30 8C23.3726 8 18 13.3726 18 20C18 26.6274 23.3726 32 30 32Z"
        fill="#BC002D"
      />
    </Svg>
  )
}
